import { Component, ViewChild, OnInit, ViewEncapsulation } from '@angular/core';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { SearchComponent } from '../../components/common/search/search.component';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';
import { SelectableItem } from '../../models/common/selectableItem';
import { MatchingCaSearchRequest, MatchingCaSummaryDto } from '../../models/contract.awards/matching.contract.award.models';
import { MatchingContractAwardService } from '../../services/matching.contract.award.service';
import { NoticeStatus } from '../../models/notices/notice.enums';
import { DateRangeModel } from '../../models/common/date.range';
import { BlockUI } from 'ng-block-ui';
import { CheckTenderDto } from '../../models/tenders/matching.tender.models';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';
import { UpdateAwardsDto } from '../../models/account/account.models';
import { AccountService } from '../../services/account.service';
import { AuthService } from '../../auth/auth.service';
import { PermissionsHub } from '../../signalr/permissions.hub';

@Component({
    selector: 'contractAwards/mymatches',
    template: require('./my.matches.component.html'),
    styles: [require('./my.matches.component.css')],
    encapsulation: ViewEncapsulation.None
})
export class CaMatchesComponent extends SearchComponent<MatchingCaSearchRequest,
    MatchingCaSummaryDto> implements OnInit {
    private readonly fromUrlKey = 'matchingContractAwardId';

    options: Array<SelectableItem<string>>;
    statuses: Array<SelectableItem<NoticeStatus>>;
    showSearch = true;
    resultOptions;
    enableFilters: boolean;

    datePickerOptions: any;

    publishedDate: DateRangeModel;

    loading:boolean = false;
    isUpdatingAwards: boolean = false;

    @BlockUI('ca-results-block') private resultsBlock;
    @ViewChild('deleteModal', { static: false }) private deleteModal: any;
    @ViewChild('resultsPage', { static: false }) private resultsView;

    subscribed: boolean;
    dialogName: string;
    dialogHeader: string;
    dialogBody: string;

    multiSelect: Array<string>;

    csvAwardsDialogHeader: string;
    csvAwardsDialogBody: string;

    clicked: boolean;

    private readonly user: LoggedInUser;

    constructor(private readonly matchingContractAwardService: MatchingContractAwardService,
        helpers: Helpers,
        private readonly configuration: Configuration,
        loggedInUserService: LoggedInUserService,
        private readonly cmsDialogService: CmsDialogService,
        private readonly accountService: AccountService,
        private authService: AuthService) {
        super(new MatchingCaSearchRequest(configuration), matchingContractAwardService, helpers);

        this.user = loggedInUserService.getCurrentUser();

        this.request.supplierId = this.user.supplierId;
        this.enableFilters = this.user.canAdHoc('contractAwardFilters');
        this.clicked = false;

        this.options = [
            {
                text: 'Most Recent',
                value: 'B2BRef'
            },
            {
                text: 'Start Date',
                value: 'StartDate'
            },
            {
                text: 'End Date',
                value: 'EndDate'
            },
            {
                text: 'Type',
                value: 'Type'
            },
            {
                text: 'Title',
                value: 'Title'
            }
        ];

        this.statuses = [
            {
                text: 'Live',
                value: NoticeStatus.Live
            },
            {
                text: 'Expired',
                value: NoticeStatus.Expired
            }
        ];

        this.resultOptions = {
            availableButtons: ['removeResult', 'print', 'bookmark', 'removeMultiple']
        };

        this.publishedDate = new DateRangeModel();

        this.subscribed = !this.user.canAdHoc('notSubscribed');
    }
    
    ngOnInit() {
        document.body.classList.add('matching-awards-fit');

        $('#invalid-contractaward-modal').modal();
        $('#invalid-contractaward-modal').modal('hide');

        PermissionsHub.startHub(this.authService, this.configuration, this.user.userId);

        var selectedId = localStorage.getItem(this.fromUrlKey);

        if (this.subscribed) {
            this.dialogName = 'Matching Awards Info - Subscribed';
        }
        else {
            this.dialogName = 'Matching Awards Info - Not Subscribed';
        }

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        this.cmsDialogService.getByDescription('Matching Awards CSV Warning').subscribe((result: CmsDialogDto) => {
            this.csvAwardsDialogHeader = result.header;
            this.csvAwardsDialogBody = result.body;
        });

        if (selectedId) {
            this.request.noticeId = JSON.parse(selectedId) as number;
            localStorage.removeItem(this.fromUrlKey);

            this.matchingContractAwardService.checkTender(this.request.noticeId).subscribe((result: CheckTenderDto) => {
                var isValid = result.isValid;

                if (isValid) {
                    if (result.noticeStatus == NoticeStatus.Expired) {
                        this.request.status = NoticeStatus.Expired;
                    }
                }

                if (!isValid) {
                    $('#invalid-contractaward-modal').modal();
                }

                super.ngOnInit();
            });
        }
        else {
            super.ngOnInit();
        }        
    }

    ngOnDestroy() {
        document.body.classList.remove('matching-awards-fit');
        $('#invalid-contractaward-modal').modal('hide');
        $('#matching-awards-info-modal').modal('hide');
        $('#delete-modal').modal('hide');
        $('#matching-awards-csv-modal').modal('hide');
        $('#multi-modal').modal('hide');
    }

    removeMatch(award: MatchingCaSummaryDto) {
        this.deleteModal.showAndPopulate(award, award.title);
    }

    removeMatches(ids: Array<string>) {
        this.multiSelect = ids;

        if (ids.length > 0) {
            $('#multi-modal').modal();
        }
    }

    confirmMultiRemoval() {
        $('#multi-modal').modal('hide');
        this.matchingContractAwardService.removeMatches(this.multiSelect)
            .subscribe(() => {
                this.ngOnInit();
            });
    }

    confirmRemove(award: MatchingCaSummaryDto) {
        this.deleteModal.clearAndHide();

        this.matchingContractAwardService.removeMatch(award.id)
            .subscribe(() => {
                var idx = this.results.data.indexOf(award);

                if (idx > -1) {
                    this.results.data.splice(idx, 1);
                    this.results.totalRecords -= 1;
                }

                this.resultsView.clearSelectedIfMatch(award.b2BRef) 
            });
    }

    search() {
        this.resultsBlock.start();
        this.loading = true;
        const publishedDateDto = this.publishedDate.convertDatesToDto();

        this.request.publishedDateFrom = publishedDateDto.startDate;
        this.request.publishedDateTo = publishedDateDto.endDate;
        this.request.descending = false;

        if (this.request.sortProperty == 'B2BRef') {
            this.request.descending = true;
        }

        return super.search();
    }

    searchCallback(results) {
        super.searchCallback(results);

        if (this.resultsView) {
            this.resultsView.onSearchComplete();
        }

        this.resultsBlock.stop();
        this.loading = false;

        if (this.request.noticeId) {
            if (this.results) {
                if (this.results.data.length > 0) {
                    if (this.results.data[0].b2BRef != this.request.noticeId) {
                        $('#invalid-contractaward-modal').modal();
                    }
                }
            }
            else {
                $('#invalid-contractaward-modal').modal();
            }

            this.request.noticeId = null;
        }
    }

    updateAwards() {
        if (this.isUpdatingAwards) {
            return;
        }

        var dto: UpdateAwardsDto = {
            supplierId: this.request.supplierId
        };

        this.isUpdatingAwards = true;
        this.resultsBlock.start();

        this.accountService.updateAwards(dto).subscribe(() => {
            this.search();
            this.isUpdatingAwards = false;
            this.resultsBlock.stop();
        }, () => {
            this.isUpdatingAwards = false;
            this.resultsBlock.stop();
        });

    }

    showInfoDialog() {
        $('#matching-awards-info-modal').modal();
    }

    public downloadCsv(): void {

        if (this.results.totalRecords > 200) {
            $('#matching-awards-csv-modal').modal();
        }
        else {
            this.continueDownload();
        }
    }

    public continueDownload(): void {
        $('#matching-awards-csv-modal').modal('hide');
        this.clicked = true;
        this.matchingContractAwardService.downloadCsv(this.request);
        this.clicked = false;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/contract.awards/my.matches.component.ts